import { Button, Select, TSelectOption } from "@r360/library";
import React from "react";
import { useStore } from "react-redux";
import { useNavigate } from "react-router-dom";
import { syncStateToBrowserStorage } from "../../configureStore";
import useAppDispatch from "../../hooks/useAppDispatch";
import useTranslate from "../../hooks/useTranslate";
import { signOutUser } from "../../store/actions/account";
import { signOutAgent } from "../../store/actions/clientData";
import { TAgent } from "../../store/types";
import { Col, Container, Row } from "react-bootstrap";

type TAgentBar = {
    currentSite: string;
    agent: TAgent;
};

export const AgentBar = ({ currentSite, agent }: TAgentBar) => {
    const navigate = useNavigate();
    const t = useTranslate();
    const store = useStore();
    const dispatch = useAppDispatch();

    const agentSites = agent.sites.map(site => {
        return {
            label: site.site_name,
            value: site.site_name,
        };
    });

    const handleChangeSite = (siteName: string) => {
        // Find seleted site among agent sites.
        const site = agent.sites.find(site => site.site_name === siteName);
        if (site) {
            window.location.href = site.href;
        }
    };

    const handleLogoutAgent = () => {
        if (agent.isDev) {
            dispatch(signOutUser("")).then((loggedOut: boolean) => {
                if (!loggedOut) {
                    return;
                }

                dispatch(signOutAgent());
                syncStateToBrowserStorage(store)();
                navigate("/");
            });

            return;
        }

        if (agent.logoutUrl) {
            // Sign out logged in user.
            dispatch(signOutUser("")).then((loggedOut: boolean) => {
                if (!loggedOut) {
                    return;
                }

                dispatch(signOutAgent());
                syncStateToBrowserStorage(store)();
                navigate("/");
                window.location.href = agent.logoutUrl;
            });
        }
    };

    return (
        <div className="u-bg-light-blue u-p-6">
            <Container>
                <Row>
                    <Col className="u-d-flex u-gap-18 u-justify-content-center u-align-items-center">
                        <div>
                            {t("book.agent_bar.logged_in_as")} <span className="u-fw-medium">{agent.name}</span>
                        </div>
                        <Select
                            options={agentSites}
                            type="standard"
                            defaultValue={currentSite}
                            onSelectCallback={(selected: TSelectOption) => handleChangeSite(selected.value.toString())}
                            disabled={agent.isDev}
                        />
                        <Button type="tertiary" onClick={handleLogoutAgent}>
                            {t("book.general.log_out")}
                        </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};
